import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import { IconButton, TableCell } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

interface IFinancialConditionTableDeleteCellProps {
  label: string;
  disabled: boolean;
  hidden?: boolean;
  onDelete: () => void;
}

export const FinancialConditionTableDeleteCell: React.FC<
  IFinancialConditionTableDeleteCellProps
> = ({ label, disabled, hidden = false, onDelete }) =>
  hidden ? null : (
    <TableCell sx={financialConditionGenerationStyles.editableTableActionCell}>
      <IconButton
        aria-label={label}
        onClick={onDelete}
        disabled={disabled}
        color="error"
        size="small"
      >
        <DeleteOutlineIcon />
      </IconButton>
    </TableCell>
  );
